import { sprintf } from '@wordpress/i18n';

import * as React from 'react';
import { WidgetId } from '@Utils/edge/constants';
import useMediaQuery from '@Utils/core/hooks/useMediaQuery-v3';
import useDefineDevice from '@Utils/core/hooks/useDefineDevice';
import * as automationLabels from '@Utils/facade/edgeTs/automationLabels';
import useWidget from '@Utils/core/useWidget';
import * as Styled from './GameGeneratorPromoted.styled';
import GameGeneratorPromotedMobile from './GameGeneratorPromotedMobile';
import GeneratorContext from '../../../GeneratorContext';

const GameGeneratorPromoted: React.FC = () => {
  const globalStatic = useWidget(WidgetId.GlobalStaticV3);
  const widgetGeneratorGlobal = useWidget(WidgetId.GeneratorGlobalV3);
  const { isAndroidDevice, isIosDevice } = useDefineDevice();
  const { isMobile } = useMediaQuery();

  const { generatedNickname, isGenerated } = React.useContext(GeneratorContext);

  const appleStoreLogo = React.useMemo(
    () => globalStatic.images.appleStoreLogo,
    [globalStatic.images.appleStoreLogo],
  );
  const googlePlayLogo = React.useMemo(
    () => globalStatic.images.googlePlayLogo,
    [globalStatic.images.googlePlayLogo],
  );

  const linkStore = isIosDevice
    ? widgetGeneratorGlobal.links.promoAppleStoreTop
    : widgetGeneratorGlobal.links.promoGoogleStoreTop;

  const renderTabletTemplate = () => (
    <Styled.Wrapper
      href={linkStore}
      target="_blank"
      {...automationLabels.getProps('promoted.game.generator.link.store')}
    >
      <Styled.IconContainer>
        <Styled.IconElement
          src={widgetGeneratorGlobal.images.promoGameIcon.src}
          alt={widgetGeneratorGlobal.images.promoGameIcon.alt}
        />
      </Styled.IconContainer>
      <Styled.InfoWrapper>
        <Styled.GameTitle>{widgetGeneratorGlobal.strings.promoGameTitle}</Styled.GameTitle>
        <Styled.GameGenre>{widgetGeneratorGlobal.strings.promoGenre}</Styled.GameGenre>
      </Styled.InfoWrapper>
      <Styled.StoreLogoWrapper>
        <Styled.Store>
          {isIosDevice ? (
            <Styled.StoreLogo src={appleStoreLogo.src} alt={appleStoreLogo.alt} />
          ) : null}
          {isAndroidDevice ? (
            <Styled.StoreLogo src={googlePlayLogo.src} alt={googlePlayLogo.alt} />
          ) : null}
        </Styled.Store>
      </Styled.StoreLogoWrapper>
    </Styled.Wrapper>
  );

  return (
    <>
      {isGenerated ? (
        <>
          <Styled.SeoNickname>
            {sprintf(widgetGeneratorGlobal.strings.seoNicknameText, generatedNickname)}
          </Styled.SeoNickname>
          <Styled.SeoText>{widgetGeneratorGlobal.strings.seoText}</Styled.SeoText>
        </>
      ) : null}
      {isMobile ? <GameGeneratorPromotedMobile /> : renderTabletTemplate()}
    </>
  );
};

export default GameGeneratorPromoted;
